/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".container[_ngcontent-%COMP%]{max-width:400px}.search-bar[_ngcontent-%COMP%]{display:flex;margin:16px 0}.search-bar[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{flex:1;line-height:36px}.search-bar[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{line-height:36px}.pony[_ngcontent-%COMP%]{background-color:#d3d3d3;padding:8px}.pony.available[_ngcontent-%COMP%]{background-color:#20b2aa}"];
export { styles as styles };

